import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Installningar = lazy(() => import("@/pages/mina-sidor/Installningar"));

export const Route = createFileRoute("/mina-sidor/installningar")({
  component: () => <Installningar />,
});
